import { getById, getBlob, putBlob, writeAudit } from "../../db";
import { nowIso } from "../../db/schema";

export function emailBlobPath(archiveId) {
  return `local://archives/${archiveId}.email.json`;
}

export function readEmailFlags(archiveId) {
  if (!archiveId) return null;
  return getBlob(emailBlobPath(archiveId)) || null;
}

export function buildEmailFlags({ transaction, archive, exportRow, actor }) {
  const broker = getById("users", transaction.broker_id);
  const agent = getById("users", transaction.agent_id);
  const client = getById("users", transaction.client_id);
  const clientOptIn = Boolean(client?.email_report_opt_in);
  return {
    queued: true,
    queued_at: nowIso(),
    subject: `DreamHome Journey communication report — ${transaction.property_address || "file"}`,
    archive_id: archive.id,
    export_id: exportRow?.id || archive.report_export_id,
    queued_by: actor?.userId || null,
    broker: { send: true, user_id: broker?.id || transaction.broker_id, email: broker?.email || "" },
    agent: { send: true, user_id: agent?.id || transaction.agent_id, email: agent?.email || "" },
    client: {
      send: clientOptIn,
      opted_in: clientOptIn,
      user_id: client?.id || transaction.client_id,
      email: client?.email || "",
    },
    note: "Flags are queued locally. A mail server is not attached in this build.",
  };
}

export function queueArchiveEmails({ transaction, archive, exportRow, actor }) {
  const existing = readEmailFlags(archive.id);
  if (existing) {
    return { ...existing, idempotent: true };
  }
  const flags = buildEmailFlags({ transaction, archive, exportRow, actor });
  putBlob(emailBlobPath(archive.id), flags);
  writeAudit({
    user_id: actor?.userId || null,
    action_type: "email.queue",
    transaction_id: transaction.id,
    metadata: {
      archive_id: archive.id,
      export_id: flags.export_id,
      broker: true,
      agent: true,
      client: flags.client.send,
    },
  });
  return { ...flags, idempotent: false };
}

export function describeEmailFlags(flags) {
  if (!flags) return "";
  const names = [];
  if (flags.broker?.send) names.push("broker");
  if (flags.agent?.send) names.push("agent");
  if (flags.client?.send) names.push("client");
  if (!names.length) return "No report emails were queued.";
  if (names.length === 1) return `Report email queued for the ${names[0]}.`;
  if (names.length === 2) return `Report email queued for the ${names[0]} and ${names[1]}.`;
  return `Report email queued for the ${names[0]}, ${names[1]}, and ${names[2]}.`;
}
